import * as React from "react";
import {useEffect, useState} from "react";

import {LANGUAGES, MAX_FONTSIZE, MIN_FONTSIZE} from "../utils/constants";

import IconPlus from "../assets/icon-plus-square.svg";
import IconMinus from "../assets/icon-minus-square.svg";
import IconModeLight from "../assets/icon-mode-light.svg";
import IconModeDark from "../assets/icon-mode-dark.svg";

import IconPlusDark from "../assets/icon-plus-square-dark.svg";
import IconMinusDark from "../assets/icon-minus-square-dark.svg";


const PAGE_CONTENT = {
  en: {
    lang: "Language",
    font: "Font size",
    mode: "Mode",
  },
  kn: {
    lang: "ಭಾಷೆ",
    font: "ಅಕ್ಷರ ಗಾತ್ರ",
    mode: "ಮೋಡ್",
  },
}

const AccessibilityHeader = ({ onThemeChange = (() => {})}) => {
  const [selectedLang, setSelectedLanguage] = useState(typeof window !== "undefined" ? window.localStorage.getItem("lang") || "en" : "en");
  const [theme, setTheme] = useState(typeof window !== "undefined" ? window.localStorage.getItem("theme") || "light" : "light");

  useEffect(() => {
    const lsTheme = window.localStorage.getItem("theme");
    const preferenceTheme = window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    const finalTheme = lsTheme || preferenceTheme;

    setTheme(finalTheme);
    onThemeChange(finalTheme);
  }, []);

  useEffect(() => {
    window.localStorage.setItem("theme", theme);
    const htmlElement = document.querySelector("html");
    if(theme === "dark") {
      htmlElement.classList.add("dark");
      htmlElement.classList.remove("light");
      htmlElement.style.setProperty("color-scheme", "dark");
    } else {
      htmlElement.classList.remove("dark");
      htmlElement.classList.add("light");
      htmlElement.style.setProperty("color-scheme", "light");
    }
    onThemeChange(theme);
  }, [theme]);

  useEffect(() => {
    const lsLang = window.localStorage.getItem("lang");
    if (!lsLang) {
      window.localStorage.setItem("lang", selectedLang);
    } else if (lsLang !== selectedLang) {
      window.localStorage.setItem("lang", selectedLang);
      window.location.reload();
    }

    const htmlElement = document.querySelector("html");
    htmlElement.setAttribute("lang", selectedLang);
  }, [selectedLang]);

  const changeFontSize = (change) => {
    const htmlElement = document.querySelector("html");
    const currentFontsize = (htmlElement.style.fontSize ? parseInt(htmlElement.style.fontSize.substring(0, 2)) : 20) + change;
    const newFontSize = Math.min(Math.max(currentFontsize, MIN_FONTSIZE), MAX_FONTSIZE);
    htmlElement.style.fontSize = `${newFontSize}px`;
  }

  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
  }

  return (
    <div id="header-accessibility">
      <div className="header-all-item">
        <span>
          {PAGE_CONTENT[selectedLang].lang}&nbsp;&nbsp;
        </span>
        <span>
          {
            ["kn", "en"].map(lang => (
              <button
                className={`widget-type-btn ${lang === selectedLang ? "selected" : ""}`}
                key={lang}
                onClick={() => setSelectedLanguage(lang)}
              >{LANGUAGES[lang]}</button>
            ))
          }
        </span>
      </div>
      <div className="header-all-item">
        <span>{PAGE_CONTENT[selectedLang].font}&nbsp;&nbsp;</span>
        <div id="font-access-flex">
          <button className="font-icon" onClick={() => changeFontSize(4)}>
            <img src={IconPlus} alt="+" className="light" />
            <img src={IconPlusDark} alt="+" className="dark" />
          </button>
          <button className="font-icon" onClick={() => changeFontSize(-4)}>
            <img src={IconMinus} alt="-" className="light" />
            <img src={IconMinusDark} alt="-" className="dark" />
          </button>
        </div>
      </div>
      <div className="header-all-item">
        <span>
          {PAGE_CONTENT[selectedLang].mode}&nbsp;&nbsp;
        </span>
        <div>
          <button className="mode-btn" onClick={toggleTheme}>
            <img src={IconModeLight} alt="" className="light"/>
            <img src={IconModeDark} alt="" className="dark" />
          </button>
        </div>
      </div>
    </div>
  )
}

export default AccessibilityHeader;
